module.exports = __webpack_public_path__ + "img/neurolab.05930274.png";